import { addClass, hasClass, removeClass } from './dom';

type MediaDefinitions = { [s: string]: string };
const DEFAULT_MEDIA_DEFINITIONS: MediaDefinitions = {
    'palm': 'screen and (max-width: 44.9375em)',
    'lap': 'screen and (min-width: 45em) and (max-width: 63.9375em)',
    'lap-and-up': 'screen and (min-width: 45em)',
    'portable': 'screen and (max-width: 63.9375em)',
    'desk': 'screen and (min-width: 64em)',
    'retina': '(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)'
};

export function createBreakpointListeners (mediaDefinitions: MediaDefinitions = DEFAULT_MEDIA_DEFINITIONS): void {
    document.addEventListener('resize', () =>
        matchAndAssignBreakpointClasses(document.documentElement, mediaDefinitions)
    );

    matchAndAssignBreakpointClasses(document.documentElement, mediaDefinitions)
}

export function isPalm (): boolean {
    return hasClass(document.documentElement, 'palm');
}

export function isLap (): boolean {
    return hasClass(document.documentElement, 'lap');
}

export function isLapAndUp (): boolean {
    return hasClass(document.documentElement, 'lap-and-up');
}

export function isPortable (): boolean {
    return hasClass(document.documentElement, 'portable');
}

export function isDesk (): boolean {
    return hasClass(document.documentElement, 'desk');
}

function matchAndAssignBreakpointClasses (element: HTMLElement, mediaDefinitions: MediaDefinitions): void {
    Object.entries(mediaDefinitions).forEach(([className, mediaQuery]) =>
        matchMedia(mediaQuery).matches
            ? addClass(element, className)
            : removeClass(element, className)
    )
}
